import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import "url-search-params-polyfill";
import "es7-object-polyfill";

import "./index.scss";

//import $ from "jquery";
//import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

import ErrorBoundary from "./components/ErrorBoundary";
import {
  captureTrackingParams,
  persistTrackingParams,
} from "./services/trackingParams";
import { initGtag } from "./services/gtag";

// Marketing darf den Start der App unter keinen Umstaenden verhindern: Wirft hier
// etwas, wird ReactDOM.render nie erreicht und der Nutzer sieht eine weisse Seite
// ohne Fehlermeldung. Der Antrag muss auch dann funktionieren, wenn Tracking klemmt.
try {
  // Kampagnen-Parameter der Landing-URL erfassen. Laeuft bewusst vor initGtag und
  // unabhaengig vom Consent - gespeichert wird erst mit Einwilligung.
  captureTrackingParams();

  // Google Tag laden, falls Marketing-Cookies bereits akzeptiert sind
  initGtag();

  // Cookiebot feuert das Event auch beim Seitenaufruf mit bereits erteiltem Consent
  window.addEventListener('CookiebotOnAccept', function () {
    try {
      initGtag();
      persistTrackingParams();
    } catch (e) {
      // bewusst geschluckt - siehe oben
    }
  });
} catch (e) {
  // bewusst geschluckt - siehe oben
}

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
